/**
 * Convert HTML date-input values (YYYY-MM-DD in local calendar) to ISO strings
 * for the transactional email audit API (from / to query params).
 */

const YMD = /^(\d{4})-(\d{2})-(\d{2})$/

function parseYmd(yyyyMmDd: string): { y: number; m: number; d: number } | null {
  const t = yyyyMmDd.trim()
  const m = YMD.exec(t)
  if (!m) return null
  const y = Number(m[1])
  const mo = Number(m[2])
  const d = Number(m[3])
  if (mo < 1 || mo > 12 || d < 1 || d > 31) return null
  const dt = new Date(y, mo - 1, d)
  if (dt.getFullYear() !== y || dt.getMonth() !== mo - 1 || dt.getDate() !== d) return null
  return { y, m: mo, d }
}

/** Start of the given local calendar day as ISO (UTC). Returns '' if the string is not a valid Y-M-D. */
export function localDayStartIso(yyyyMmDd: string): string {
  const p = parseYmd(yyyyMmDd)
  if (!p) return ''
  return new Date(p.y, p.m - 1, p.d, 0, 0, 0, 0).toISOString()
}

/** End of the given local calendar day as ISO (UTC). Returns '' if invalid. */
export function localDayEndIso(yyyyMmDd: string): string {
  const p = parseYmd(yyyyMmDd)
  if (!p) return ''
  return new Date(p.y, p.m - 1, p.d, 23, 59, 59, 999).toISOString()
}

/** Map an ISO timestamp to YYYY-MM-DD in the user's local timezone (for date inputs). */
export function isoToLocalDay(iso: string): string {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return ''
  const y = d.getFullYear()
  const mo = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${mo}-${day}`
}
